import { areaContains, areaHeightAt, areasNear, closestPointInArea, } from "./area-geometry.js";
/** Klicks neben einer Wand oder Kante landen bis zu dieser Strecke auf der Fläche. */
export const NAVIGATION_SNAP_DISTANCE_HU = 48;
/** Kandidaten näher als das gelten als dieselbe Ebene (angrenzende Areas). */
const SAME_FLOOR_HU = 40;
/** Ab dieser lichten Höhe über dem Punkt liegt er „unter“ einer anderen Ebene. */
const COVERED_CLEARANCE_HU = 72;
/**
 * Alle Ebenen unter einem Radarpunkt, oberste zuerst. Liegt der Punkt auf
 * keiner Area, wird er auf die nächste Fläche innerhalb der Fangdistanz
 * geschoben. Pro Ebene bleibt der nächstgelegene Kandidat.
 */
export function navigationCandidates(asset, point) {
    const radius = NAVIGATION_SNAP_DISTANCE_HU / asset.huPerRadarUnit;
    const found = [];
    for (const areaId of areasNear(asset, point, radius)) {
        if (asset.areas[areaId].stone)
            continue;
        const closest = closestPointInArea(asset.areas[areaId], point);
        if (closest.distance <= radius)
            found.push({
                areaId,
                x: closest.x,
                y: closest.y,
                z: closest.z,
                snapped: closest.distance,
            });
    }
    found.sort((left, right) => left.snapped - right.snapped);
    const floors = [];
    for (const candidate of found)
        if (!floors.some((floor) => Math.abs(floor.z - candidate.z) < SAME_FLOOR_HU))
            floors.push(candidate);
    return floors.sort((left, right) => right.z - left.z);
}
/** Kandidat, dessen Höhe einem gespeicherten `z` am nächsten liegt. */
export function locationNearestHeight(candidates, z) {
    let best = null;
    for (const candidate of candidates)
        if (!best || Math.abs(candidate.z - z) < Math.abs(best.z - z))
            best = candidate;
    return best;
}
/**
 * Liegt über dem Punkt eine weitere begehbare Ebene (Mirage Underpass unter
 * Mid, Dust2 Lower Tunnels)? Dann zeichnet das Radar den Weg gestrichelt.
 */
export function isNavigationPointCovered(asset, point) {
    for (const areaId of areasNear(asset, point, 0)) {
        const area = asset.areas[areaId];
        if (!area.stone &&
            areaContains(area, point) &&
            areaHeightAt(area, point) > point.z + COVERED_CLEARANCE_HU)
            return true;
    }
    return false;
}
